module.exports = __webpack_public_path__ + "img/to-bottom-arrow.c840043a.svg";